import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-deb15dc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-customBg card tw-items-dashed-group tw-document-sender" }
const _hoisted_2 = { class: "card-header d-flex justify-content-between align-items-center" }
const _hoisted_3 = { class: "card-title mb-0" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    opacity: "0.5",
    x: "6",
    y: "17.3137",
    width: "16",
    height: "2",
    rx: "1",
    transform: "rotate(-45 6 17.3137)",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    x: "7.41422",
    y: "6",
    width: "16",
    height: "2",
    rx: "1",
    transform: "rotate(45 7.41422 6)",
    fill: "currentColor"
  })
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "card-body pt-2 pb-2" }
const _hoisted_7 = { class: "row form-group mb-0" }
const _hoisted_8 = { class: "col-lg-12 col-md-12 col-sm-12 form-control no-border" }
const _hoisted_9 = { class: "d-block mb-0 small text-muted" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "row form-group mb-0" }
const _hoisted_12 = { class: "col-lg-12 col-md-12 col-sm-12 form-control no-border" }
const _hoisted_13 = { class: "col-12" }
const _hoisted_14 = { class: "card-footer d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_searchable_select = _resolveComponent("searchable-select")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_spinner_facebook = _resolveComponent("q-spinner-facebook")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("task.printDocument.sentCTA")), 1),
      _createElementVNode("span", {
        class: "cursor-pointer",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("task.printDocument.templateForwardDocuments.recipient")), 1),
          _createVNode(_component_searchable_select, {
            dense: "",
            outlined: "",
            multiple: "",
            modelValue: _ctx.emailSendList,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.emailSendList) = $event)),
            options: _ctx.senderEmails?.items
          }, null, 8, ["modelValue", "options"])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templateSelected, (template, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createVNode(_component_q_btn, {
              class: "btn btn-action btn-sm font-size-12",
              icon: "close",
              label: template.fileName,
              onClick: ($event: any) => (_ctx.removeFile(template))
            }, null, 8, ["label", "onClick"])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_q_input, {
              type: "textarea",
              "bg-color": "white",
              dense: "",
              outlined: "",
              disable: "",
              "model-value": _ctx.body,
              class: "w-100"
            }, null, 8, ["model-value"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_q_btn, {
        class: "btn btn-primary",
        label: _ctx.$t('task.printDocument.sentCTA'),
        icon: "send",
        onClick: _ctx.sendMail,
        loading: _ctx.isLoadingSend,
        disable: _ctx.emailSendList.length === 0
      }, {
        loading: _withCtx(() => [
          _createVNode(_component_q_spinner_facebook)
        ]),
        _: 1
      }, 8, ["label", "onClick", "loading", "disable"])
    ])
  ]))
}